import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, IconButton } from 'react-toolbox';
import ColoredButton from 'components/ColoredButton';
import S from 'modal.scss';

const DepartedChecklistModal = ({ active, onConfirm, onClose }) => (
  <Dialog
    active={active} className={S.modal} type="fullscreen"
    onEscKeyDown={onClose} onOverlayClick={onClose}
  >
    <IconButton icon="close" className={S.close} onClick={onClose} />
    <h5 className={S.title}>Before marking Departed, please confirm you have:</h5>
    <ul>
      <li>LRRP/photos & checklist (if applicable)</li>
      <li>Inquiry Flags (if applicable)</li>
      <li>Communication Notes</li>
      <li>Relevant Job Photos</li>
      <li>Review your Labor Sheet for accuracy</li>
    </ul>
    <div className={S.actions}>
      <ColoredButton color="green" responsive label="Confirm" className={S.button} onClick={onConfirm} />
      <ColoredButton color="darkGray" responsive label="Cancel" className={S.button} onClick={onClose} />
    </div>
  </Dialog>
);

DepartedChecklistModal.propTypes = {
  active: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DepartedChecklistModal;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/departedChecklistModal.jsx